import App, {Tool} from '../App';
import Api from './Api';
import Resource from '../Resource';

class Product {
    static data(props) {
        App.log('PRODUCT.PRODUCT_INFO', App.LOG.FETCH, props);

        const body = {
            productId: null,
            productNumber: props.productNumber,
        };

        return new Promise((resolve, reject) => {
            fetch(Api.PRODUCT.DATA, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        if (result.objList?.length)
                            resolve(result.objList);
                        else
                            reject('فرآورده پیدا نشد.');
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static delete(props) {
        App.log('PRODUCT.DELETE', App.LOG.FETCH, props);

        const body = {
            incomingId: props.productId,
            statusId: 11
        };

        return new Promise((resolve, reject) => {
            fetch(Api.PRODUCT.STATE_UPDATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.DELETE_FAILED);
            });
        });
    }

    static destroy(props) {
        App.log('PRODUCT.DESTROY', App.LOG.FETCH, props);

        const body = {
            incomingId: props.productId,
            statusId: 14,
            reasonId: parseInt(props.destroyedReasonId)
        };

        return new Promise((resolve, reject) => {
            fetch(Api.PRODUCT.STATE_UPDATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.DELETE_FAILED);
            });
        });
    }

    static insert(props) {
        App.log('PRODUCT.INSERT', App.LOG.FETCH, props);

        const body = {
            productVM: {
                // productId: 0,
                productNumber: props.productNumber,
                productTypeId: parseInt(props.productTypeId),
                bloodGroupId: parseInt(props.bloodGroupId),
                expireDate: props.expireDate,
                collectionDate: props.collectionDate,
                cellTypeTest: props.cellTypeTest
            }
        };

        return new Promise((resolve, reject) => {
            fetch(Api.PRODUCT.INSERT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList[0]);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.INSERT_FAILED);
            });
        });
    }

    static insertFirstInventory(props) {
        App.log('PRODUCT.INSERT_FIRST_INVENTORY', App.LOG.FETCH, props);

        const body = {
            receiverUserId: props.receiverUserId,
            receiveDateTime: props.receiveDateTime,
            productNumber: props.productNumber,
            productTypeId: parseInt(props.productTypeId),
            bloodGroupId: parseInt(props.bloodGroupId),
            expireDate: props.expireDate,
            collectionDate: props.collectionDate,
            cellTypeTest: props.cellTypeTest
        };

        return new Promise((resolve, reject) => {
            fetch(Api.PRODUCT.INSERT_FIRST_INVENTORY, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList[0]);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.INSERT_FAILED);
            });
        });
    }

    static retrieve(props) {
        App.log('PRODUCT.RETRIEVE', App.LOG.FETCH, props);

        const body = {
            incomingId: props.productId,
            statusId: 13,
            reasonId: parseInt(props.hospitalReturnReasonId)
        };

        return new Promise((resolve, reject) => {
            fetch(Api.PRODUCT.STATE_UPDATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static track(props) {
        App.log('PRODUCT.TRACK', App.LOG.FETCH, props);

        const body = {
            productNumber: props.productNumber,
        };

        return new Promise((resolve, reject) => {
            fetch(Api.PRODUCT.TRACK, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        if (result.objList)
                            resolve(result.objList);
                        else
                            reject('فرآورده پیدا نشد.');
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static update(props) {
        App.log('PRODUCT.UPDATE', App.LOG.FETCH, props);

        const body = {
            productVM: {
                productId: props.productId,
                productNumber: props.productNumber,
                productTypeId: parseInt(props.productTypeId),
                bloodGroupId: parseInt(props.bloodGroupId),
                expireDate: props.expireDate,
                collectionDate: props.collectionDate,
                cellTypeTest: props.cellTypeTest
            }
        };

        return new Promise((resolve, reject) => {
            fetch(Api.PRODUCT.UPDATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }
}

export default Product;